import React from 'react'
import styled from 'styled-components';
import { Link } from "@reach/router";
import toLink from '../utils/to-link';

const Frame = styled.span`
margin-right: 10px;
  `;

const Paragraph = styled.p`
margin-top: 32px;
`

const VeaseTambien = ({articulo}) => {

    const { relacionados } = articulo

    if (!relacionados || relacionados.length === 0) return <></>

    return <>
        <Paragraph>Véase También: {relacionados.map(relacionado => <Frame><Link to={`/articulo/${toLink(relacionado)}`}>{relacionado}</Link></Frame>)}</Paragraph>
    </>
}

export default VeaseTambien